import {
  BUSINESS_ROLE_GROUPS,
  EXTERNAL_OPERATOR_ROLE_GROUPS,
} from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import ApplyAmendment from '../pages/ApplyAmendment';
import AmendmentHistory from '../pages/AmendmentHistory';

const RESTRICTED_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...EXTERNAL_OPERATOR_ROLE_GROUPS.restricted,
];

const AmendmentsRoutes: RouteObject[] = [
  {
    path: 'amendments',
    children: [
      {
        path: '',
        element: (
          <Authorize
            permission={RESTRICTED_PERMISSIONS}
            fallback={<ErrorPage code={403} />}
          >
            <ApplyAmendment />
          </Authorize>
        ),
      },
      {
        path: 'history',
        element: (
          <Authorize
            permission={RESTRICTED_PERMISSIONS}
            fallback={<ErrorPage code={403} />}
          >
            <AmendmentHistory />
          </Authorize>
        ),
      },
    ],
  },
];

export default AmendmentsRoutes;
